import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 255.4 189.99"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M1.26 139.73 0 189.99c2.46-.39 5.16-.79 8.06-1.21l-4.2-49.05zm250.28 0-4.2 49.05c2.91.42 5.6.82 8.06 1.21l-1.26-50.26zM26.94 101.6l-1.33 84.87c3.41-.41 6.99-.81 10.73-1.21l-6.57-84.14-2.83.47Zm192.12 83.66c3.74.4 7.32.8 10.73 1.21l-1.33-84.87-2.83-.47-6.57 84.14ZM48.6 87.66l-2.26 96.6c3.92-.37 7.99-.72 12.19-1.05l-6.62-95.55zm154.89 0-6.62 95.55c4.2.33 8.27.68 12.19 1.05l-2.26-96.6zM68.29 182.5c4.36-.29 8.84-.56 13.44-.8L74.52 71.19l-2.83-.24-3.4 111.54ZM180.88 71.19l-7.21 110.51c4.6.24 9.08.5 13.44.8l-3.4-111.54-2.83.24Zm-25.14-41.2-6.52 107.04-21.29 14.03-21.29-14.03-6.52-107.04h-2.77l-5.76 151.26q8.625-.345 17.7-.51l-2.04-33.56 20.43 27.2 20.91-27.28-2.06 33.81c5.82.16 11.73.39 17.72.69L158.48 30h-2.77.03Zm-38.76-19.27c0 5.92 4.8 10.72 10.72 10.72s10.72-4.8 10.72-10.72S133.62 0 127.7 0s-10.72 4.8-10.72 10.72",
  "data-name": "Livello_1",
  style: {"fill":"#fff"}
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }